/* SW + Install Prompt registration */
let deferredInstallPromptEvent = null;

export function registerSW() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // register after load to avoid blocking initial paint
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredInstallPromptEvent = e;
    window.dispatchEvent(new CustomEvent('gt:installable', { detail: true }));
  });
  window.addEventListener('appinstalled', () => {
    deferredInstallPromptEvent = null;
    window.dispatchEvent(new CustomEvent('gt:installed', { detail: true }));
  });
}

export async function promptInstall() {
  if (!deferredInstallPromptEvent) return { outcome: 'unavailable' };
  const evt = deferredInstallPromptEvent;
  deferredInstallPromptEvent = null;
  evt.prompt();
  try {
    const choice = await evt.userChoice;
    return choice;
  } catch {
    return { outcome: 'error' };
  }
}

export function isInstallReady() {
  return !!deferredInstallPromptEvent;
}
